import AsyncStorage from '@react-native-async-storage/async-storage';
import { CALC_ROUTE_SET } from './calcRegistry';

const KEY = 'tabai.usedCalcs.v1';

export type UsedCalcs = {
  /** Map of calc route -> last-used Unix ms */
  routes: Record<string, number>;
};

export async function loadUsedCalcs(): Promise<UsedCalcs> {
  try {
    const raw = await AsyncStorage.getItem(KEY);
    if (!raw) return { routes: {} };
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object' || !parsed.routes) return { routes: {} };
    return { routes: parsed.routes };
  } catch {
    return { routes: {} };
  }
}

export async function markCalcUsed(route: string): Promise<void> {
  if (!CALC_ROUTE_SET.has(route)) return;
  try {
    const current = await loadUsedCalcs();
    current.routes[route] = Date.now();
    await AsyncStorage.setItem(KEY, JSON.stringify(current));
  } catch {
    // ignore
  }
}

export async function clearUsedCalcs(): Promise<void> {
  try {
    await AsyncStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
